import React from 'react';
import { Typography, Box, SxProps, Theme } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { getCurrentContestPhase } from '../EsContestSubmission/helper';
import { IContest } from '../../types/global/helper';
import CalendarIcon from '../CustomSVGIcons/CalendarIcon';
import { StyledBadge } from '../StyledBadge';

interface IEsCalendarTag {
    contest: IContest;
    sx?: SxProps<Theme>;
}

const EsCalendarTag: React.FC<IEsCalendarTag> = ({ contest, sx }) => {
    const { themeStyle } = useThemeContext();
    const isLive = getCurrentContestPhase(contest).toLocaleLowerCase() === 'join contest';

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            sx={{
                gap: '4px',
                backgroundColor: isLive ? theme[themeStyle].primary_red : theme[themeStyle].primary_orange,
                borderRadius: 1,
                height: '22px',
                paddingTop: '2px',
                paddingBottom: '2px',
                marginLeft: '22px',
                marginRight: '22px',
                marginTop: '20px',
                paddingRight: 1,
                paddingLeft: 1,
                zIndex: 2,
                ...sx,
            }}>
            <CalendarIcon
                height={12}
                width={12}
                fill={isLive ? theme[themeStyle].true_white : theme[themeStyle].black}
                stroke={isLive ? theme[themeStyle].true_white : theme[themeStyle].black}
            />
            <Typography
                style={{
                    fontSize: 12,
                    fontWeight: '500',
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    textAlign: 'left',
                    color: isLive ? theme[themeStyle].true_white : theme[themeStyle].pure_black,
                    textTransform: 'capitalize',
                }}>
                {getCurrentContestPhase(contest)}
            </Typography>
            {isLive && (
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    variant="dot"
                    sx={{
                        mx: 1,
                    }}
                />
            )}
        </Box>
    );
};

export { EsCalendarTag };
